import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ihxgqwki5y: FaireBrandEntity = {
  token: "b_ihxgqwki5y",
  type: "brand",
  name: "Atlas Screen Printing",
  avatarUrl:
    "https://cdn.faire.com/fastly/e9c00488ab10bba4848bb2fab770ac4701acd3fe933a41a3827991ddcf133b1e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7f894c8c00f2dec2a425d419c855d2f9d4b1a4584317addb59e5f01099362b84.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e9c00488ab10bba4848bb2fab770ac4701acd3fe933a41a3827991ddcf133b1e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7f894c8c00f2dec2a425d419c855d2f9d4b1a4584317addb59e5f01099362b84.jpeg",
  location: "Gainesville, FL, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 15,
  isInsider: true,
  description:
    "\nAtlas Screen Printing is the maker of two award winning premium product line - WILD COTTON® and CROSSWALKS®.  \n\nFor over thirty years, Atlas Screen Printing has developed a reputation for presenting high quality screen printed and embroidered images on t-shirts, tote bags, caps, sweat shirts, and other garments. We also screen print on metal, plastic, polyboard and coroplast. All of our designs are now available on ceramic coffee mugs.\n\nOur in house graphics arts department can take your project from start to finish, using either your own design or you can let us create something unique just for you.\n\nAtlas Screen Printing combines a blend of scientific accuracy, artistic style, and quality craftsmanship. We strive to present the highest quality art with award winning graphics and printing.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:42.579Z",
    importedBy: "entity-db-cli",
  },
};
